export default function checkIfCanSeeSuggestionRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  let exists = scopes.includes('suggestions_list_company') || scopes.includes('suggestions_list_all');
  return exists ? next() : next({ name: 'dashboard' });
}
